export const PAGE_SIZE = [10, 20, 30, 40, 50];
